import React from 'react';
import Avatar from 'components/Avatar';
import _ from 'lodash';
import paperBin from 'assets/images/think/paperbin.svg';

import { UserWrapper } from './styles';

function UserSmallCard(props) {
  const {
    user, literals, recognized, actualUser, onDelete, buttonVoteUp, tags, onClick, showDeleteButton,
    isDragging,
  } = props;

  const click = () => {
    if (onClick && !isDragging) {
      onClick(user.id);
    }
  };

  const handleDelete = (event) => {
    if (onDelete) {
      onDelete(user.id);
    }

    event.stopPropagation();
  };


  return (
    <UserWrapper key={user.id} className='user_wrapper' onClick={click}>
      <div>
        <Avatar
          key={user.id}
          id={user.id}
          avatar={user.avatar}
          firstname={user.firstname}
          size={52}
          isChampion={!!user.is_recognized}
        />
        <div className='userContent'>
          <div className='name'>
            {`${user.firstname} ${user.lastname}`}
          </div>
          {user.contributions ? (
            <div className='contributions'>
              <div>{literals.contributions}</div>
              {_.map(tags, cont => (
                <div key={cont} className='contribution tag gray'>{cont}</div>
              ))}
            </div>) : null}
          {buttonVoteUp}
        </div>
      </div>
      {(recognized || showDeleteButton) && user.id !== actualUser.id && <div className='delete'><img src={paperBin} alt='' className='paperbin' data-user={user.id} onClick={handleDelete} /></div>}
    </UserWrapper>
  );
}

export default UserSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/UserSmallCard/components/index.jsx